
export const taxonomyApiUrl = '/taxonomy-service/';
export const taxonomyJobsUrl = '/jobs/';
export const authApiUrl = '/auth/';
export const translateApiUrl = '/translations/translation/groupings/';
export const publicTranslateApiUrl = '/translations/translation/public/groupings/';
export const usermgmtApiUrl = '/usermgmt/';
export const queriesApiUrl = '/queries/';
export const importApiUrl = '/import/';
export const occurrencesApiUrl = '/occurrences/';
export const migrationApiUrl = '/migration/';
export const notificationsApiUrl = '/notifications/';


export const SAFETY_RECOMMENDATIONS_API_URL = occurrencesApiUrl + 'recommendations/public/getPublished';
export const SAFETY_RECOMMENDATION_DETAILS_API_URL = occurrencesApiUrl + 'recommendations/public/get';
export const TAXONOMY_VERSION_RELEASED_BY_AUTHORITY_PUBLIC_API_URL = taxonomyApiUrl + 'public/getReleasedByAuthority/2';
export const TAXONOMY_ATTRIBUTE_VALUES_API_URL = taxonomyApiUrl + 'attributes/';
export const TAXONOMY_ATTRIBUTE_VALUES_FIRST_LEVEL_API_URL = taxonomyApiUrl + 'attributes/public/showFirstLevelValues';
export const TAXONOMY_ATTRIBUTE_API_URL = taxonomyApiUrl + 'attributes/public/byTaxonomyCodeAndReferenceId';
